export const bartDalyWestOakland = [
    [37.70624740031143, -122.46899897170641], // BART Daly City
    [37.70904638137617, -122.46658903824704],
    [37.70982500889729, -122.46541405487358],
    [37.71006652673833, -122.46435568104548],
    [37.71005522018419, -122.45858092032623],
    [37.710354024415636, -122.45626785589667],
    [37.711201395795094, -122.4543144569385],
    [37.71505354941722, -122.44970596242291],
    [37.71606322379549, -122.44883977493829],
    [37.71722583093106, -122.44829499968313],
    [37.7188234997677, -122.44809828588171],
    [37.721709393604435, -122.44741807119449], // BART Balboa Park
    [37.724770933344686, -122.44651683672616],
    [37.72562139749788, -122.4460052503194],
    [37.72673701746046, -122.44512518350886],
    [37.72786269779638, -122.44359555136066],
    [37.729843865478934, -122.43927576509009],
    [37.73323635322208, -122.43346012900454], // BART Glen Park
    [37.73941922130502, -122.42435119491823],
    [37.74020943934382, -122.42355429275635],
    [37.74124845000579, -122.422732720706],
    [37.748306312083756, -122.4181141151784],
    [37.75222289279655, -122.41852639240409], // BART 24th St Mission
    [37.765379907884466, -122.41979544923527], // BART 16th St Mission
    [37.772050311211096, -122.42038351464971],
    [37.773644051233745, -122.41993214464861],
    [37.77512369622189, -122.41910686579328],
    [37.77562084109104, -122.41873376331655],
    [37.77956379514448, -122.4137196092685], // BART Civic Center
    [37.7843490642855, -122.40804511030784], // BART Powell St
    [37.78939611430761, -122.40117601414059], // BART Montgomery St
    [37.79293856027791, -122.39702374502227], // BART Embarcadero
    [37.79899555598394, -122.38888877228342],
    [37.80014662395084, -122.38669630246413],
    [37.81012071631552, -122.34212660844065],
    [37.81058984891128, -122.33887426228112],
    [37.81026880444282, -122.33298396232539],
    [37.808975097070544, -122.31838213530663],
    [37.80790626888733, -122.30735480394326],
    [37.80774898818961, -122.30642642285595],
    [37.80597391907348, -122.29808654169192],
    [37.80482517793759, -122.2952694298787], // BART West Oakland
    [37.80312919895131, -122.2907879713957],
    [37.80269327027139, -122.28905489239243],
    [37.801647097918384, -122.28453910174318],
    [37.801111654076024, -122.28328335602775],
    [37.798636645865585, -122.27827086870796],
    [37.79857792842283, -122.27606786470474],
];